import EventBus from './EventBus';

let windowInFocus = false;

export const addClass = (element, className) => {
  const classNames = element.className.split(' ');
  const pos = classNames.indexOf(className);

  if (pos === -1) {
    element.className = classNames.concat([className]).join(' ');
  }
};

export const removeClass = (element, className) => {
  const classNames = element.className.split(' ');
  const pos = classNames.indexOf(className);

  if (pos !== -1) {
    classNames.splice(pos, 1);
    element.className = classNames.join(' ');
  }
};

(() => {
  let hidden = 'hidden';

  // Standards:
  if (hidden in document) {
    document.addEventListener('visibilitychange', onChange);
  } else if ('mozHidden' in document) {
    hidden = 'mozHidden';
    document.addEventListener('mozvisibilitychange', onChange);
  } else if ('webkitHidden' in document) {
    hidden = 'webkitHidden';
    document.addEventListener('webkitvisibilitychange', onChange);
  } else if ('msHidden' in document) {
    hidden = 'msHidden';
    document.addEventListener('msvisibilitychange', onChange);
  } else if ('onfocusin' in document) {
    document.onfocusin = onChange;
    document.onfocusout = onChange;
  } else {
    window.onpageshow = onChange;
    window.onpagehide = onChange;
    window.onfocus = onChange;
    window.onblur = onChange;
  }

  function onChange (evt) {
    const v = 'visible';
    const h = 'hidden';
    const evtMap = {
      focus: v,
      focusin: v,
      pageshow: v,
      blur: h,
      focusout: h,
      pagehide: h
    };

    evt = evt || window.event;
    if (evt.type in evtMap) {
      document.body.setAttribute('hidetest', evtMap[evt.type]);
    } else {
      document.body.setAttribute('hidetest', this[hidden] ? 'hidden' : 'visible');
    }
    if (document.body.getAttribute('hidetest') === 'visible') {
      windowInFocus = true;
      EventBus.notify(EventBus.TYPE.WINDOW_FOCUSED);
    } else {
      windowInFocus = false;
      EventBus.notify(EventBus.TYPE.WINDOW_BLURRED);
    }
  }

  // set the initial state (but only if browser supports the Page Visibility API)
  if (document[hidden] !== undefined) {
    onChange({ type: document[hidden] ? 'blur' : 'focus' });
  }
})();

export const isWindowInFocus = () => windowInFocus;
